export const NetworkContextName = 'NETWORK';
export const YEAR_IN_SECONDS = 365 * 24 * 3600;
